module.exports = __webpack_public_path__ + "static/media/MontyPythonHolyGrail.47ad278f.png";